import { z } from 'zod';
export const onboardingApplicationStatusSchema = z.enum([
    'InProgress',
    'Submitted',
    // Set by approving the validation.
    'Validated',
    'Abandoned',
]);
export const isResumableOnboardingStatus = (status) => status === onboardingApplicationStatusSchema.enum.InProgress ||
    status === onboardingApplicationStatusSchema.enum.Abandoned;
export const onboardingStepSchema = z.enum([
    'work-categories',
    'regions',
    'account',
    'company',
    'validation',
    'registration-channel',
    'subscription',
]);
